import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'react-i18next'

import { Avatar, Box, ListItem, ListItemAvatar, ListItemButton, ListItemText, Stack, Typography } from '@mui/material'

dayjs.extend(relativeTime)

export type NotificationMenuItemProps = {
  createdAt: string
  isRead: boolean
  label: string
  onClick?: () => void
}

function NotificationMenuItem({ createdAt, isRead, label, onClick }: NotificationMenuItemProps) {
  const { i18n } = useTranslation()

  return (
    <ListItem disablePadding sx={{ px: 1 }}>
      <ListItemButton alignItems="flex-start" onClick={onClick} sx={{ '&:hover': { borderRadius: 2 } }}>
        <ListItemAvatar>
          <Avatar alt="Remy Sharp" />
        </ListItemAvatar>
        <Stack flex={1} direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <ListItemText
            primary={
              <Typography component="span" variant="body1" sx={{ color: !isRead ? '#050505' : '#65676B', display: 'block' }}>
                {label}
              </Typography>
            }
            secondary={
              dayjs(createdAt).isValid() ? (
                <Typography
                  component="span"
                  variant="body2"
                  sx={[{ color: '#65676B', display: 'block' }, !isRead && { color: (theme) => theme.palette.primary.main, fontWeight: 600 }]}
                >
                  {dayjs(createdAt).locale(i18n.language).fromNow()}
                </Typography>
              ) : null
            }
          />
          {!isRead && (
            <Stack height="100%" alignItems="center" justifyContent="center">
              <Box sx={{ display: 'inline-block', borderRadius: '50%', width: 10, height: 10, bgcolor: 'primary.main' }} />
            </Stack>
          )}
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}

export default NotificationMenuItem
